import { SiteRoleEnum } from 'domains/roleDomain';
import { useRole, useUser } from 'hooks';
import { useOrgId } from './useOrg';
import React from 'react';

export const useDemoFeatureFlags = () => {
  const user = useUser();
  const orgId = useOrgId();
  const { buyerRole } = useRole();
  const phoenixEnhancements = buyerRole && orgId === 42;
  const isSupplier = user?.siteRole === SiteRoleEnum.Supplier;

  const transformValue = (node: React.ReactNode) => {
    if (phoenixEnhancements) {
      return '--';
    }
    return node;
  };

  return {
    jobResultViewQuoteFlag: isSupplier,
    phoenixEnhancements,
    transformValue,
  };
};
